module.exports = __webpack_public_path__ + "img/20190805161433802.e9805a82.png";